import { createContext, useContext } from "react";

// Provides navigate(sectionId) to any section/component in the tree.
export const NavContext = createContext(() => {});
export const useNavigate = () => useContext(NavContext);
